var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"quote-flowX-overview"},[_c('div',{staticClass:"stock-info-box"},[_c(_setup.FlowXStockPrice,{attrs:{"stock-quote-data":_setup.stockQuoteData}}),_c(_setup.FlowXStockIndex,{attrs:{"stock-quote-data":_setup.stockQuoteData}})],1),_c(_setup.AbbeChat,{ref:"refAbbeChat",staticClass:"stock-box-chart"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }